import StagesTable from '../StagesTable';

export default StagesTable;
